import {defineStore} from 'pinia';
import {contacts} from "@js/company_details.ts";
import {checkDocument} from '@js/helpers.ts';

export const useThemeStore = defineStore('themeStore', {
    state: () => ({
        footer_with_map: true,
        body_overflow_hidden: true,
        toasts: [],
        minimize_ui: false,
    }),
    actions: {
        turnOffMap() {
            this.footer_with_map = false
        },
        turnOnMap() {
            this.footer_with_map = true
        },
        resetMap() {
            this.footer_with_map = true
        },
        setBodyOverflow(hidden) {
            this.body_overflow_hidden = hidden
            document.body.style.overflow = this.body_overflow_hidden ? 'hidden' : '';

            //Понижает z-index для jivosite чтобы не мешало отображению элементов сайта
            const jdiv = document.querySelector('jdiv')
            if (jdiv) {
                if (hidden) {
                    // запомним исходный z-index один раз
                    if (!jdiv.dataset.prevZ) {
                        const z = getComputedStyle(jdiv).zIndex
                        jdiv.dataset.prevZ = (z ?? '').toString()
                    }
                    jdiv.style.zIndex = '0'
                } else {
                    // вернём исходный z-index или уберём инлайн-стиль
                    const prev = jdiv.dataset.prevZ
                    if (prev && prev !== 'auto' && prev !== '') {
                        jdiv.style.zIndex = prev
                    } else {
                        jdiv.style.removeProperty('z-index')
                    }
                    delete jdiv.dataset.prevZ
                }
            }
        },
        addToast(message, type, linkData = null, timeout = 3000) {
            const id = Date.now() + Math.random().toString(36).substring(2, 9);
            this.toasts.push({id, message, type, linkData})

            let vm = this
            if (this.toasts.length >= 3) {
                this.removeToast(this.toasts[0].id);
            }

            setTimeout(() => {
                vm.removeToast(id)
            }, timeout)
        },
        removeToast(id) {
            this.toasts = this.toasts.filter(toast => toast.id !== id)
        },
    }
});
